import type {
  IFiveFormData,
  IFourFormData,
  IOneTemplateFormData,
  IThreeFormData,
  ITwoTemplateFormData,
  IWithoutTemplateFormData,
} from '~/entities/projects/model/templates-interface'
import type { SchemaType } from '~/shared/lib'
import { computed } from 'vue'
import { FormField } from '~/shared/const'

const SUBTITLE_LABEL = 'Подзаголовок'
const TEXT_BLOCK_LABEL = 'Текстовый блок'

function subtitleField<TName extends string>(name: TName): SchemaType<TName> {
  return {
    name,
    label: SUBTITLE_LABEL,
    type: FormField.string,
    required: true,
    attrs: {
      placeholder: 'Введите подзаголовок...',
    },
  }
}

function textBlockField<TName extends string>(
  name: TName,
  height = '120px',
): SchemaType<TName> {
  return {
    name,
    label: TEXT_BLOCK_LABEL,
    type: FormField.textarea,
    required: true,
    attrs: {
      height,
      placeholder: 'Введите текст...',
    },
  }
}

export const OneHeaderSchema = computed<SchemaType<keyof IOneTemplateFormData>[]>(() => [
  textBlockField('description'),
])

export const OneSectionSchema = computed<SchemaType<keyof IOneTemplateFormData>[]>(() => [
  subtitleField('sectionTitle'),
  textBlockField('sectionDescription'),
])

export const OneLeftBlockSchema = computed<SchemaType<keyof IOneTemplateFormData>[]>(() => [
  subtitleField('leftBlockTitle'),
  textBlockField('leftBlockText'),
])

export const OneRightBlockSchema = computed<SchemaType<keyof IOneTemplateFormData>[]>(() => [
  subtitleField('rightBlockTitle'),
  textBlockField('rightBlockText'),
])

export const twoTemplateHeaderSchema = computed<SchemaType<keyof ITwoTemplateFormData>[]>(() => [
  textBlockField('description'),
])

export const twoTemplateLeftHeaderSchema = computed<SchemaType<keyof ITwoTemplateFormData>[]>(() => [
  subtitleField('leftSectionTitle'),
  textBlockField('leftSectionDescription'),
])

export const twoTemplateRightHeaderSchema = computed<SchemaType<keyof ITwoTemplateFormData>[]>(() => [
  subtitleField('rightSectionTitle'),
  textBlockField('rightSectionDescription'),
])

export const twoTemplateAdditionalSectionSchema = computed<SchemaType<keyof ITwoTemplateFormData>[]>(() => [
  subtitleField('bottomSectionTitle'),
  textBlockField('bottomSectionDescription'),
])

export const threeTemplateHeaderSchema = computed<SchemaType<keyof IThreeFormData>[]>(() => [
  textBlockField('description'),
])

export const threeTemplateLeftHeaderSchema = computed<SchemaType<keyof IThreeFormData>[]>(() => [
  subtitleField('leftSectionTitle'),
  textBlockField('leftSectionDescription'),
])

export const threeTemplateCenterHeaderSchema = computed<SchemaType<keyof IThreeFormData>[]>(() => [
  subtitleField('centerSectionTitle'),
  textBlockField('centerSectionDescription'),
])

export const threeTemplateRightHeaderSchema = computed<SchemaType<keyof IThreeFormData>[]>(() => [
  subtitleField('rightSectionTitle'),
  textBlockField('rightSectionDescription'),
])

export const threeTemplateTextImageSectionSchema = computed<SchemaType<keyof IThreeFormData>[]>(() => [
  subtitleField('textImageSectionTitle'),
  textBlockField('textImageSectionDescription'),
])

export const threeTemplateAdditionalSectionSchema = computed<SchemaType<keyof IThreeFormData>[]>(() => [
  subtitleField('bottomSectionTitle'),
  textBlockField('bottomSectionDescription'),
])

export const fourTemplateHeaderSchema = computed<SchemaType<keyof IFourFormData>[]>(() => [
  textBlockField('description'),
])

export const fourTemplateFirstHeaderSchema = computed<SchemaType<keyof IFourFormData>[]>(() => [
  subtitleField('firstSectionTitle'),
  textBlockField('firstSectionDescription'),
])

export const fourTemplateSecondHeaderSchema = computed<SchemaType<keyof IFourFormData>[]>(() => [
  subtitleField('secondSectionTitle'),
  textBlockField('secondSectionDescription'),
])

export const fourTemplateThirdHeaderSchema = computed<SchemaType<keyof IFourFormData>[]>(() => [
  subtitleField('thirdSectionTitle'),
  textBlockField('thirdSectionDescription'),
])

export const fourTemplateAdditionalSectionSchema = computed<SchemaType<keyof IFourFormData>[]>(() => [
  subtitleField('bottomSectionTitle'),
  textBlockField('bottomSectionDescription'),
])

export const fiveTemplateHeaderSchema = computed<SchemaType<keyof IFiveFormData>[]>(() => [
  textBlockField('description'),
])

export const fiveTemplateLeftHeaderSchema = computed<SchemaType<keyof IFiveFormData>[]>(() => [
  subtitleField('leftSectionTitle'),
  textBlockField('leftSectionDescription'),
])

export const fiveTemplateRightHeaderSchema = computed<SchemaType<keyof IFiveFormData>[]>(() => [
  subtitleField('rightSectionTitle'),
  textBlockField('rightSectionDescription'),
])

export const fourTemplateOneSecondHeaderSchema = computed<SchemaType<keyof IFourFormData>[]>(() => [
  subtitleField('secondHeaderTitle'),
  textBlockField('secondHeaderDescription'),
])

export const fiveTemplateAdditionalSectionSchema = computed<SchemaType<keyof IFiveFormData>[]>(() => [
  subtitleField('bottomSectionTitle'),
  textBlockField('bottomSectionDescription'),
])

export const fiveTemplateAdditionalSecondarySectionSchema = computed<SchemaType<keyof IFiveFormData>[]>(() => [
  subtitleField('bottomSecondarySectionTitle'),
  textBlockField('bottomSecondaryDescription'),
])

export const withoutTemplateSchema = computed<SchemaType<keyof IWithoutTemplateFormData>[]>(() => [
  {
    name: 'shortDescription',
    label: 'Краткое описание',
    type: FormField.string,
    required: true,
    attrs: {
      height: '120px',
      maxlength: 200,
      placeholder: 'Кратко опишите ваш проект...',
    },
  },
  {
    name: 'detailedDescription',
    label: 'Подробное описание',
    type: FormField.textarea,
    required: true,
    attrs: {
      height: '178px',
      placeholder: 'Подробно опишите ваш проект...',
    },
  },
])
